import { render, staticRenderFns } from "./BranchPicker.vue?vue&type=template&id=2d8ce99b&scoped=true&"
import script from "./BranchPicker.vue?vue&type=script&lang=js&"
export * from "./BranchPicker.vue?vue&type=script&lang=js&"
import style0 from "./BranchPicker.vue?vue&type=style&index=0&id=2d8ce99b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ce99b",
  null
  
)

export default component.exports